import { FileRenderer } from '../enums';

export const ImageExtensions = {
    jpeg: '.jpeg',
    jpg: '.jpg',
    png: '.png',
    gif: '.gif',
    svg: '.svg',
    bmp: '.bmp',
};

export const VideoExtensions = {
    mp4: '.mp4',
    mov: '.mov',
};

export const FileExtensions = {
    stl: '.stl',
    ply: '.ply',
    spr: '.spr',
    obj: '.obj',

    pdf: '.pdf',
    docx: '.docx',
    txt: '.txt',

    dicom: '.dicom',
    zip: '.zip',

    drc: '.drc',
    folder: '.folder',
    sdsplink: '.sdsplink',

    ...VideoExtensions,
    ...ImageExtensions,
} as const;

export const FileExtensionToRenderer: Record<string, FileRenderer> = {
    [FileExtensions.stl]: FileRenderer.threedViewer,
    [FileExtensions.sdsplink]: FileRenderer.sdsplink,
    [FileExtensions.pdf]: FileRenderer.pdf,
    ...Object.values(ImageExtensions).reduce((acc, c) => ({ ...acc, [c]: FileRenderer.image }), {}),
    ...Object.values(VideoExtensions).reduce((acc, c) => ({ ...acc, [c]: FileRenderer.video }), {}),
};
